export function getInitialWorkoutExercises({ workout, readOnly }) {
  if (readOnly) return workout?.data?.exercises || [];
  return [];
}

export function getInitialWorkoutSets({ workoutExercise, readOnly }) {
  if (readOnly) return workoutExercise?.sets || [];
  return [];
}
